import { InfoValue } from "../channels/types";
import { AclMemberDto } from "../security/types";
import { TemplateTypeEnum } from "../templates/types";
import { Player } from "../players/types";

export interface Solution {
    id: string;
    name: string;
    autoScale: boolean;
    timeZoneId: string;
    timeZoneName: string;
    height: number;
    width: number;
    templateId: string | null;
    templateName: string | null;
    templateType: TemplateTypeEnum;
    folderId: string;
    playerId: string | null;
    powerPlanId: string | null;
    forceOn: string;
    acl: AclMemberDto[];
    type: SolutionTypeEnum;
    contractId: string | null;
    playerName: string;
    properties: any;
    status: boolean;
    lastActiveDate: string;
    player?: Player
}
export interface CopySolution {
    solutionId: string,
    name: string,
    copyUserAccess: boolean,
}

export interface SolutionInfo {
    name: string,
    height: number,
    width: number,
    templateId: string;
    templateName: string;
    type: SolutionTypeEnum,
    contractName: string,
    playerId: number,
    playerName: string,
    playerPcName:string,
    status: boolean;
    lastActiveDate: string;
    solutionFolderPath: string;
}

export interface SolutionsFilterDtoIn {
    templateId: string,
    solutionTypes: string[]
}

export interface Settings {
    name: string;
    autoScale: boolean;
    timeZoneId: string;
    timeZoneName: string;
    height: number;
    width: number;
    templateId: string | null;
    templateName: string | null;
    templateType: TemplateTypeEnum;
    type: SolutionTypeEnum;
    contractId: string | null;
    powerPlanId: string | null;
    playerId: string | null;
    playerName: string;
    properties: any;
}

export interface AddContractDto{
    solutionId: string;
    contractId: string
}

export enum SolutionTypeEnum
{
    informationScreen = 1,
    receptionScreen,
    guestRegistration,
    meetingOverview,
    interactiveInformationScreen,
    wayfinder,
    meetingRoomScreen,
    sessions,
    digitalPoster,
    screenWall,
    supernovaWall,
    calmviso
}
